import axios from 'axios';
import { generateCaching } from '../functions/caching';
import { URI } from '../config';
import { isValidSlug, isValidUUID, isValidPointId } from '../functions/validation';

const initializeMenu = async (placeId, userId, pointId, delivery) => {
  // Validate inputs before making API call
  if (!isValidSlug(placeId)) {
    console.error('Invalid placeId format');
    return { place: {}, cache: {}, status: 400, md5: 0, imguuid: 0 };
  }
  if (!isValidUUID(userId)) {
    console.error('Invalid userId format');
    return { place: {}, cache: {}, status: 400, md5: 0, imguuid: 0 };
  }
  if (!isValidPointId(pointId)) {
    console.error('Invalid pointId format');
    return { place: {}, cache: {}, status: 400, md5: 0, imguuid: 0 };
  }

  try {
    const data = await axios.get(
      `${URI.menu}?id=${encodeURIComponent(placeId)}&userId=${encodeURIComponent(
        userId,
      )}&pointId=${encodeURIComponent(pointId)}&delivery=${delivery}`,
    );

    const {
      status,
      data: { menu: menuData, delivery: deliveryData, md5, imguuid },
    } = data;

    const hasDeliveryAndNoData = delivery && deliveryData === undefined;
    const noDeliveryModeButNoMenu = !delivery && menuData === undefined;

    if (status !== 200 || hasDeliveryAndNoData || noDeliveryModeButNoMenu) {
      return { place: {}, cache: {}, status, md5: 0, imguuid: 0 };
    }

    const { place, categories, toppingsGroups, toppings, products, services, events } = delivery
      ? deliveryData
      : menuData;

    const cache = generateCaching({
      place,
      categories,
      toppingsGroups,
      toppings,
      products,
      services,
      events,
      imguuid,
    });

    return { place, cache, status, md5, imguuid };
  } catch (error) {
    console.error('error', error);
    if (error?.response?.status === 401) {
      return { place: {}, cache: {}, status: 401, md5: 0, imguuid: 0 };
    }

    return { place: {}, cache: {}, status: 500, md5: 0, imguuid: 0 };
  }
};

export { initializeMenu };
